export default __webpack_public_path__ + "static/premium-banner-img-mobile-9d81decf54a4f1e5d048346f4c57b877.png";